function PoliciesMainContent({ children }) {
  return <div className="md:mx-[4em] m-4 md:my-[2em]">{children}</div>;
}

export default PoliciesMainContent;
